import type {FC} from 'react';
import React from 'react';
import styles from './label.module.scss';
import {Text, TextSize} from '../text';

interface LabelProps {
  text: string;
  htmlFor?: string;
  smallScreenText?: string;
  smallScreenThreshold?: number;
  isBold?: boolean;
  noMargin?: boolean;
}

export const Label: FC<LabelProps> = ({noMargin = false, ...props}) => {
  let text;
  if (props.smallScreenText !== undefined) {
    text = (
      <>
        <Text size={TextSize.XXSMALL} val={props.text} bold={props.isBold} />
        <Text size={TextSize.XXSMALL} val={props.smallScreenText} bold={props.isBold} />
      </>
    );
  } else {
    text = <Text size={TextSize.XXSMALL} val={props.text} bold={props.isBold} />;
  }

  return (
    <label className={`${noMargin ? styles.noMargin : styles.label}` + ' body-xxs'} htmlFor={props.htmlFor}>
      {text}
    </label>
  );
};
